import * as Three from "three" 


export class Renderable3 {
  __geometry: Three.BufferGeometry
  __material: Three.Material
  __texture: Three.Texture
  public __mesh: Three.Mesh

  constructor() { }

  public get mesh(): Three.Mesh {
    return this.__mesh
  }

  public destroy3() {
    if (!this.__mesh) return;

    // 1. Remove from parent (the scene or a group)
    if (this.__mesh.parent) {
      this.__mesh.parent.remove(this.__mesh);
    }

    // 2. Dispose of geometry
    if (this.__mesh.geometry) {
      this.__mesh.geometry.dispose();
    }
  }
}